import { _ } from "../../polyglot/polyglot.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import FiscalYearWidget from "./FiscalYearWidget.js";

/**
 * `FiscalYearList` is a section of `selectDataStepWidget` to select the
 * dimension object to import per fiscal year.
 *
 * @param {Array} [fiscalYears=[]] - Array of fiscal year mockups to display
 * @param {boolean} [selectOnlyLatestFiscalYear] - When this option is true, only the
 *   latest fiscal year is selected, otherwise all the fiscal years will be
 *   selected.
 */
export default class FiscalYearsList extends Widget {
	constructor({ fiscalYears = [], selectOnlyLatestFiscalYear = false } = {}) {
		super(...arguments);
		this._selectOnlyLatestFiscalYear = selectOnlyLatestFiscalYear;
		this.setFiscalYears(fiscalYears);
	}

	setFiscalYears(years) {
		if (!years) {
			return;
		}

		this._fiscalYears = years.sort((a, b) =>
			new Date(a.start) < new Date(b.start) ? 1 : -1,
		);

		this._fiscalYearsWidget = this._fiscalYears.map(
			(fiscalYear, index) =>
				new FiscalYearWidget({
					fiscalYear,
					selected: this._isSelected(index),
				}),
		);

		this.update();
	}

	getFiscalYears() {
		return this._fiscalYearsWidget
			.filter((widget) => widget.isSelected())
			.map((widget) => widget.getData());
	}

	renderContentOn(html) {
		html.div(
			{ klass: "form-group objects", "data-test": "fiscal-year-picker" },
			html.label({ klass: "control-label col-sm-4" }, _("Objects")),
			html.div(
				{ klass: "col-sm-8" },
				html.div(
					{ klass: "fiscal-year-picker" },
					this._fiscalYearsWidget,
				),
			),
		);
	}

	_isSelected(index) {
		return (
			!this._selectOnlyLatestFiscalYear ||
			(this._selectOnlyLatestFiscalYear && index === 0)
		);
	}
}
